export default __webpack_public_path__ + "static/media/cat.4f2f96f3.svg";